import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { API_BASE } from "../config";

function friendlyError(err, isSignUp) {
  const msg = (err?.message || "").toLowerCase();
  if (msg.includes("user already registered") || msg.includes("already been registered")) {
    return "An account with this email already exists. Try signing in instead.";
  }
  if (msg.includes("invalid login credentials") || msg.includes("invalid credentials")) {
    return "Incorrect email or password. Please try again.";
  }
  if (msg.includes("email not confirmed")) {
    return "Please confirm your email address before signing in. Check your inbox.";
  }
  if (msg.includes("password should be at least") || msg.includes("password must be")) {
    return "Password must be at least 6 characters.";
  }
  if (msg.includes("unable to validate email") || msg.includes("invalid email")) {
    return "Please enter a valid email address.";
  }
  if (msg.includes("rate limit") || msg.includes("too many requests")) {
    return "Too many attempts. Please wait a moment and try again.";
  }
  if (msg.includes("auth not configured")) {
    return "Authentication is not set up for this app.";
  }
  return err?.message || "Something went wrong. Please try again.";
}

export default function AuthModal({ onClose }) {
  const { signIn, signUp } = useAuth();
  const [isSignUp, setIsSignUp] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);
    try {
      if (isSignUp) {
        await signUp(email, password);
        setMessage("Check your email to confirm your account, then sign in.");
      } else {
        const { session } = await signIn(email, password);
        if (session?.access_token) {
          await fetch(`${API_BASE}/api/auth/sync`, {
            method: "POST",
            headers: { Authorization: `Bearer ${session.access_token}` },
          }).catch(() => {});
        }
        onClose();
      }
    } catch (err) {
      setError(friendlyError(err, isSignUp));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ob-modal-overlay" onClick={onClose}>
      <div className="ob-modal" onClick={(e) => e.stopPropagation()}>
        <button className="ob-modal-close" onClick={onClose} aria-label="Close">✕</button>
        <h2 className="ob-modal-title">{isSignUp ? "Create an account" : "Sign in"}</h2>
        <form onSubmit={handleSubmit} className="ob-modal-form">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="login-input"
            required
            autoComplete="email"
            autoFocus
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="login-input"
            required
            autoComplete={isSignUp ? "new-password" : "current-password"}
            minLength={6}
          />
          {error && <p className="login-error">{error}</p>}
          {message && <p className="login-message">{message}</p>}
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "…" : isSignUp ? "Sign up" : "Sign in"}
          </button>
        </form>
        <button
          type="button"
          className="login-toggle"
          onClick={() => { setIsSignUp((v) => !v); setError(""); setMessage(""); }}
        >
          {isSignUp ? "Already have an account? Sign in" : "Need an account? Sign up"}
        </button>
      </div>
    </div>
  );
}
